module.exports = __webpack_public_path__ + "img/orgPic.1f936268.jpg";